import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hca-main',
  templateUrl: './hca-main.component.html',
  styleUrls: ['./hca-main.component.scss']
})
export class HcaMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/hotel-chain-management/hca-main/hca-main.component.ts